export const WEBINAR_DATA = "WEBINAR_DATA";
export const WEBINAR_START_LOADER = "WEBINAR_START_LOADER";
export const WEBINAR_STOP_LOADER = "WEBINAR_STOP_LOADER";
export const WEBINAR_HIDE_ERROR = "WEBINAR_HIDE_ERROR";
export const WEBINAR_SET_ERROR = "WEBINAR_SET_ERROR";
